<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";
import router from "@/router";

const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = (type, data) => {
  uiStore.setModalAction(type);
  uiStore.setModalState(true);
  uiStore.setModalData(data);

  if (type == 'edit_data_source') {
    router.push(`/data-source/${data.id}`);
  }
};
</script>

<template>
  <div class="actions-cell">
    <button @click="action('edit_data_source', props.data)" type="button" class="icon-button" title="Edit">
      <LIcon name="pencil" />
    </button>
    <button @click="action('delete_data_collection', props.data)" type="button" class="icon-button danger" title="Delete">
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
